import { Text } from "@ottatech/design";

import { IDashboardBannerNotification } from "..";

import { Notification } from "schema";

const FullProfileContent: React.FC = () => (
  <>
    <Text>
      Congratulations! You&apos;ve filled out your Otta profile. Now it&apos;s
      time to find the perfect job! 🎉
    </Text>
  </>
);

export const FullProfileNotification: IDashboardBannerNotification = {
  key: "full-profile-notification",
  name: Notification.FullProfile,
  Content: FullProfileContent,
  level: "positive",
};
